import { InputField } from 'components/molecules'

const MarketingDiscountBatchStartField = () => (
  <InputField
    type='date'
    name='start_batch_job_at'
    label='Start Discount Date'
  />
)

export default MarketingDiscountBatchStartField
